import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";

export const Tabs = ({ items, active, onChange, state }) => {
  const list = Object.values(items);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflowX: "auto",
          minHeight: "max-content",
          //   border: "1px solid #e0e0e0",
          borderRadius: ".2em",
        }}
      >
        <Box
          sx={{
            display: "flex",
            background: "#0669BF",
            width: "100%",
            py: 0.2,
            // height: "2.5em",
            // minHeight: 200,
            // minHeight: "auto",
            border: "1px solid #e0e0e0",
            borderRadius: ".2em",
            boxShadow: 2,
            alignItems: "center",
          }}
        >
          {list &&
            Array.isArray(list) &&
            list.map((item, i) => {
              const { name } = item;
              return (
                // name === state
                // ?
                // null
                //  :
                <Box
                  key={i}
                  sx={{
                    background: "#0669BF",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    pl: 3,
                    pr: 3,
                    py: 0.5,
                    cursor: "pointer",
                    borderRight: "2px solid white",
                    justifyContent: "center",
                    // minWidth: 200,
                  }}
                  onClick={() => {
                    onChange(name);
                  }}
                >
                  <Typography
                    variant="p"
                    color={active == name ? "#F2CD5E" : "white"}
                    sx={{ fontWeight: active == name ? "bold" : "normal" }}
                  >
                    {name}
                  </Typography>
                </Box>
              );
            })}
        </Box>
      </Box>
    </>
  );
};
